<template>
  <v-dialog
    :value="show"
    persistent
    slot="activator"
    content-class="confirm-dialog"
    @keydown.esc="cancel()"
  >
    <v-card>
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click.stop="cancel()">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title">{{ options.title }}</span>
      </v-app-bar>
      <v-card-text>
        <p class="subheading grey--text text--darken-1">
          {{ options.content }}
        </p>
        <p class="caption error--text text--darken-1" v-if="options.alertHint">
          {{ options.alertHint }}
        </p>
        <p class="caption info--text text--darken-1" v-if="options.infoHint">
          {{ options.infoHint }}
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.stop="cancel()">{{ options.cancel }}</v-btn>
        <v-btn class="error" @click.stop="ok()">{{ options.ok }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";
import { EventBus } from "../../../bus";
import {
  BOT_CONFIRM_DIALOG_OPEN,
  BOT_CONFIRM_DIALOG_CANCEL,
  BOT_CONFIRM_DIALOG_OK
} from "../../../mixins/dialogs.mixin";

export default {
  name: "bot-confirm-dialog",
  data() {
    return {
      show: false,
      options: {
        title: null,
        content: null,
        alertHint: null,
        infoHint: null,
        ok: null,
        cancel: null
      }
    };
  },
  methods: {
    open(options) {
      this.options = Object.assign({}, this.options, options || {});
      this.show = true;
    },
    cancel() {
      this.show = false;
      EventBus.$emit(BOT_CONFIRM_DIALOG_CANCEL);
    },
    ok() {
      this.show = false;
      EventBus.$emit(BOT_CONFIRM_DIALOG_OK);
    }
  },
  mounted() {
    EventBus.$on(BOT_CONFIRM_DIALOG_OPEN, this.open);
    this.options.title = this.resx.labels.confirm;
    this.options.content = this.resx.messages.areYouSure;
    this.options.ok = this.resx.labels.ok;
    this.options.cancel = this.resx.labels.cancel;
  },
  destroyed() {
    EventBus.$off(BOT_CONFIRM_DIALOG_OPEN, this.open);
  }
};
</script>

<style lang="scss">
.confirm-dialog {
  width: auto;
  max-width: 600px;
  

  .v-card__text p {
    margin-bottom: 0px;
    font-size: 1.1rem;
  }

  .v-card .v-card__text {
    padding: 24px 20px;
  }
}
</style>
